import * as React from "react";
import { Modal, Row, Col, Button } from "react-bootstrap";
import { TipoDatos } from "../../config_general/modelo/TipoDatos";
import { Parametro } from "../modelo/AdminParametro";
import { Form } from "react-final-form";
import InputTextBox from "../../config_general/componentes/InputTextBox";
import TextoInput from "../../../general/componentes/TextoInput";

export class ModalGestionarParametro extends React.Component<ModalGestionarParametroProps, any> {

    constructor(props: any) {
        super(props);

        this.state = {
        };
    }

    render() {
        return (
            <div>
                <Modal bsSize="large" backdrop='static' show={this.props.show} onHide={this.cancelar}>
                    <Modal.Body>
                        {this.renderFormularioGlosas()}
                    </Modal.Body>
                </Modal>
            </div>
        );
    }

    renderFormularioGlosas = () => {
        const {
            esCrear,
            codigo,
            valor1,
            valor2,
            valor3,
            valor4
        } = this.props;

        return (
            <div>
                <Form
                    onSubmit={this.onSubmit}
                    validate={this.validate}
                    initialValues={{
                        codigo: codigo,
                        valor1: valor1,
                        valor2: valor2,
                        valor3: valor3,
                        valor4: valor4
                    }}
                    render={({ handleSubmit, invalid, errors, form, submitting, pristine, values }) => (
                        <form onSubmit={handleSubmit}>
                            <div className={"card"}>
                                <div className={"card-header"}>
                                    <h3 className={"panel-title"}>{this.props.titulo}</h3>
                                </div>
                                <div className={"card-body"}>
                                    <Row className={"form-group"}>
                                        <Col sm={12}>
                                            <label htmlFor="codigo">Nombre</label>
                                            <TextoInput name="codigo" placeholder="Ingrese valor" maxLength={100} disabled={!esCrear}/>
                                        </Col>
                                    </Row>
                                    <Row className={"form-group"}>
                                        <Col sm={12}>
                                            <label htmlFor="valor1">Primer Valor</label>
                                            <InputTextBox name={"valor1"} tamano={100} maxLength={2000} />
                                        </Col>
                                    </Row>
                                    <Row className={"form-group"}>
                                        <Col sm={12}>
                                            <label htmlFor="valor2">Segundo Valor</label>
                                            <InputTextBox name={"valor2"} tamano={100} maxLength={2000} />
                                        </Col>
                                    </Row>
                                    <Row className={"form-group"}>
                                        <Col sm={12}>
                                            <label htmlFor="valor3">Tercer Valor</label>
                                            <InputTextBox name={"valor3"} tamano={100} maxLength={2000} />
                                        </Col>
                                    </Row>
                                    <Row className={"form-group"}>
                                        <Col sm={12}>
                                            <label htmlFor="valor4">Cuarto Valor</label>
                                            <InputTextBox name={"valor4"} tamano={100} maxLength={30000} />
                                        </Col>
                                    </Row>
                                    <div style={{ marginTop: `25px` }}>
                                        <Modal.Footer>
                                            <Button type="submit" className={"btns btns-primary"} disabled={submitting || invalid} >Aceptar</Button>
                                            <Button className={"btns btns-secondary"} onClick={this.cancelar}>Cancelar</Button>
                                        </Modal.Footer>
                                    </div>
                                </div>
                            </div>
                        </form>
                    )}
                />
            </div>
        );
    }

    validate = (values: any) => {
        const errors = {
            codigo: undefined
        };

        if (!values.codigo)
            errors.codigo = "Por favor ingrese el nombre del parametro";

        return errors;
    }

    onSubmit = (values: any) => {
        const codigo = values.codigo ? values.codigo.valueOf() : undefined;
        const valor1 = values.valor1 ? values.valor1.valueOf() : undefined;
        const valor2 = values.valor2 ? values.valor2.valueOf() : undefined;
        const valor3 = values.valor3 ? values.valor3.valueOf() : undefined;
        const valor4 = values.valor4 ? values.valor4.valueOf() : undefined;

        const parametro: Parametro = {
            tipo: TipoDatos.PARAMETRO,
            codigo: codigo,
            valor1: valor1,
            valor2: valor2,
            valor3: valor3,
            valor4: valor4,
            dniIngresa: this.props.dniIngresa,
            fechaIngresa: this.props.fechaIngresa
        };

        this.props.onAceptar(parametro);
    }

    cancelar = () => {
        this.props.onCancelar();
    }
}

interface ModalGestionarParametroProps {
    titulo: string,
    esCrear: boolean,
    codigo: string,
    valor1: string,
    valor2: string,
    valor3: string,
    valor4: string,
    dniIngresa: string,
    fechaIngresa: string,
    show: boolean,
    onAceptar?: (parametro: Parametro) => void,
    onCancelar?: () => void
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_parametros/componentes/ModalGestionarParametro.tsx